// be sure event names are uniq
export enum HandshakeEvent {
  Ping = 'EDITOR_PLATFORM_TRANSPORT_EVENT:__Ping',
  RequestPort = 'EDITOR_PLATFORM_TRANSPORT_EVENT:__RequestPort',
  Pong = 'EDITOR_PLATFORM_TRANSPORT_EVENT:__Pong',
  Port = 'EDITOR_PLATFORM_TRANSPORT_EVENT:__Port',
}

export enum HandshakeEvent_Deprecated {
  Greeting = 'Greeting',
  RequestPort = 'RequestPort',
  Port = 'Port',
}

export type ConsumerEvent =
  | {
      type: HandshakeEvent.Ping;
    }
  | {
      type: HandshakeEvent.RequestPort;
      memberId: string;
    }
  /**
   * @deprecated
   * backward compatibility
   */
  | {
      type: HandshakeEvent_Deprecated.Greeting;
      memberId: string;
    }
  /**
   * @deprecated
   * backward compatibility
   */
  | {
      type: HandshakeEvent_Deprecated.RequestPort;
      memberId: string;
    };

export type HostEvent =
  | {
      type: HandshakeEvent.Pong;
    }
  | {
      type: HandshakeEvent.Port;
      targetMemberId: string;
    };
